import Vue from "vue";
import Router from "vue-router";
import routes from "./router";
import { isLogin } from "@/assets/utils/utils";

Vue.use(Router);
const router = new Router({
  // mode: 'history',
  linkActiveClass: "rouerActive",
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.path != "/wlogin") {
    let obj = {
      path: to.path,
      query: to.query,
    };
    localStorage.setItem("localUrl", JSON.stringify(obj));
    next();
  } else {
    next();
  }
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
